import ApiService from '@/api';
import { ProjectModel, ResponseModel } from '@/models';
import {
  mapCheckInviteToEstimateRequest,
  mapCheckInviteToEstimateResponse,
  mapGetProjectRequest,
  mapGetProjectResponse,
} from './AdapterServiceMappers';
import CheckProjectAccessRequest from '@/models/CheckProjectAccessRequest';
import CheckProjectAccessResponse from '@/models/CheckProjectAccessResponse';
import WeeekOptionsSwitchEnableRequest from '@/models/WeeekOptionsSwitchEnableRequest';
import WeeekOptionsSwitchEnableResponse from '@/models/WeeekOptionsSwitchEnableResponse';
import {
  CheckEstimateRequestModel,
  CheckEstimateResponseModel,
  GetInvitesEstimateListRequestModel,
  GetInvitesEstimateListResponseModel,
} from '../models';
import GetAccessCurrentUserInQueueTaskByIdRequestModel from '@/components/tasks-kanban/models/GetAccessCurrentUserInQueueTaskByIdRequestModel';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from '@/components/tasks-kanban/models/GetAccessCurrentUserInQueueTaskByIdResponseModel';

export class AdapterService {
  private readonly api = new ApiService();

  /**
   * * Получить проект
   * @param projectId ID проекта
   * @returns
   */
  getProject(projectId: number) {
    return new Promise<ResponseModel<ProjectModel>>(async (resolve) => {
      const result = new ResponseModel<ProjectModel>();

      await this.api.Main.ProjectBaseService.getIdAsync(mapGetProjectRequest(projectId))
        .then((resp) => {
          result.Value = mapGetProjectResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getProject', e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получение доступов по текущему пользователю в очереди задач по идентификатору
   */
  async getAccessCurrentUserInQueueTaskById(
    request: GetAccessCurrentUserInQueueTaskByIdRequestModel,
  ): Promise<ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponseModel>> {
    return new Promise<ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponseModel>>(
      async (resolve) => {
        const result = new ResponseModel<GetAccessCurrentUserInQueueTaskByIdResponseModel>();
        try {
          const response =
            await this.api.Main.QueueTaskAdminRoleService.getAccessCurrentUserInQueueTaskByIdAsync(
              request,
            );
          result.Value = response;
          resolve(result);
        } catch (e) {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR', e);
          return result;
        }
      },
    );
  }
  /**Проверка, приглашён ли текущий пользователь */
  checkInviteToEstimate(
    request: CheckEstimateRequestModel,
  ): Promise<ResponseModel<CheckEstimateResponseModel>> {
    return new Promise<ResponseModel<CheckEstimateResponseModel>>(async (resolve) => {
      const result = new ResponseModel<CheckEstimateResponseModel>();

      await this.api.Main.EstimateInviteService.checkEstimateAsync(
        mapCheckInviteToEstimateRequest(request.TaskId),
      )
        .then((resp) => {
          result.Value = mapCheckInviteToEstimateResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          return resolve(result);
        });
    });
  }
  /**
   * * Переключение настройки включения/выключения интеграции с Weeek
   */
  switchEnableAsync(
    request: WeeekOptionsSwitchEnableRequest,
  ): Promise<ResponseModel<WeeekOptionsSwitchEnableResponse>> {
    return new Promise<ResponseModel<WeeekOptionsSwitchEnableResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsSwitchEnableResponse>();

      await this.api.Weeek.WeeekOptionsWsController.switchEnableAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          return result;
        });
    });
  }
  /**
   * * Проврека доступа к проекту
   */
  checkProjectAccess(request: CheckProjectAccessRequest) {
    return new Promise<CheckProjectAccessResponse>(async (resolve, reject) => {
      const result = new ResponseModel<CheckProjectAccessResponse>();

      await this.api.Main.ProjectAdminRoleService.checkProjectAccessAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result.Value);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          return reject(result);
        });
    });
  }
}
